import styled from 'styled-components';

export const ComponentFooter = styled.footer`
  background-color: #FEF5E6;
  display: block;
  width: 100%;
  left: 0;
  right: 0;
  position: fixed;
  box-shadow: 0px -4px 6px rgba(31, 92, 163, .3);
`;

export const FooterButton = styled.button`
    background-color: #396AE8;
    color: #FFFFFF;
    border: none;
    display: block;
    text-align: center;
    font-size: 16px;
    white-space: nowrap;
    padding: .4rem .6rem;
    border-radius: 50px;
    width: 100%;
    @media(max-width: 380px) {
      font-size: 10px;
    }
`;
